import { render, staticRenderFns } from "./assessPoster.vue?vue&type=template&id=2f35bcbd&scoped=true"
import script from "./assessPoster.vue?vue&type=script&lang=js"
export * from "./assessPoster.vue?vue&type=script&lang=js"
import style0 from "./assessPoster.vue?vue&type=style&index=0&id=2f35bcbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f35bcbd",
  null
  
)

export default component.exports